
if(location.search.length > 0) {
  const params = new URL(location.href).searchParams;
  const inventoryLocations = params.get('inventoryLocations');
  if(inventoryLocations) {
    localStorage.setItem('locationFilter', inventoryLocations)
  }
}

let returnShopping = document.querySelector('#custom_continue_shopping_btn')

if(returnShopping) {
  returnShopping.href = "https://gentlemonsterusa.myshopify.com/collections/products" + localStorage.getItem('locationFilter');
}

